<template>
  <!-- 思维训练课程 -->
  <div class="siweixunlianke">
    <PublicCert :logo="Logo10" :type="'jy-tt'" :color="'#a00d10'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo10 from '@/assets/images/logo10.png'

export default {
  name: 'SiWeixXnLian',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo10
    }
  }
}
</script>
